import { render, staticRenderFns } from "./RuleBarRule.vue?vue&type=template&id=b9d38542&scoped=true"
import script from "./RuleBarRule.vue?vue&type=script&lang=js"
export * from "./RuleBarRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d38542",
  null
  
)

export default component.exports